import { connect } from 'react-redux';
import React, { Component } from 'react';
import { renderKBInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';

import routerActions from 'app/routerActions';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as valid from 'utils/validate';
import { subscriptionActions } from 'app/actions';
import { getSpaceVirtualCurrencyName } from 'app/selectors';
import { api,
apiUtils } from 'app/services';
import PropTypes from 'prop-types';
import {
KBFormError,
KBButton,
KBPopover,
KBPopoverTop } from
'components';

var SpaceAddMemberShipDiscountForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.parseDiscountForm = this.parseDiscountForm.bind(this);}getInitialState()
  {
    return {
      isLoading: false };

  }parseDiscountForm(
  model) {
    const { callback, isTop } = this.props;
    this.setState({
      isLoading: true });

    callback && callback(model);
    if (isTop) {
      return KBPopoverTop.close();
    }
    KBPopover.close();
  }componentWillUnmount()

  {
    this.setState({
      isLoading: false });

  }render()

  {
    const {
      fields: {
        number,
        price,
        complimentary_number,
        point,
        complimentary_point },

      error,
      submitting,
      handleSubmit,
      isTop,
      virtual_currency_name,
      quota_type } =
    this.props;
    const { isLoading } = this.state;

    const quotaType = {
      desk: 'input-frequency',
      booking: 'input-hour',
      printing: 'input-sheet' };


    return (
      <form onSubmit={handleSubmit(this.parseDiscountForm)}>
        <KBFormError error={this.props.error} />
        <div className="kb-form-header">
          <h2 className="header-title">添加折扣信息</h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={isTop ? KBPopoverTop.close : KBPopover.close} />

        </div>
        <div className="kb-form-container">
          <div className="kb-row">
            <Field name="number" component={renderKBInput}
            title="每满"
            type="number"
            isRequired={true}
            label="true"
            className="kb-form-group kb-form-c18 kb-form-alone"
            inputClass={quotaType[quota_type]}

            value={number.value} />

          </div>
          <div className="kb-row">
            <Field
            name="complimentary_number"
            component={renderKBInput}
            title="赠送"
            type="number"
            isRequired={true}
            label="true"
            className="kb-form-group kb-form-c18 kb-form-alone"
            inputClass={quotaType[quota_type]}

            value={complimentary_number.value} />

          </div>
          <div className="f-right">
            <span
            className="cancel-btn"
            onClick={isTop ? KBPopoverTop.close : KBPopover.close}>

              取消
            </span>
            <button className="certain-btn m-left-sm" type="submit">
              {isLoading ? '加载中...' : '添加'}
            </button>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  let virtual_currency_name = getSpaceVirtualCurrencyName(state);
  return {
    virtual_currency_name,
    initialValues: {
      // recurring_amount  : parseFloat(total).toFixed(2) || 0,
      // start_date,
      // end_date,
      // recurring_cycles  : 1,
      // recurring_due_day : 31
    } };

}

function mapDispatchToProps(dispatch) {
  return {};
}

SpaceAddMemberShipDiscountForm.propTypes = {
  isTop: PropTypes.bool };


const validate = values => {
  const errors = {};

  // if (valid.isPrice(values.recurring_amount)) {
  //   errors.recurring_amount = '请输入正确的价格, 小数点保留2位'
  // }

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "number",
  "price",
  "point",
  "complimentary_number",
  "complimentary_point"
];

const formConfig = {
  form: 'SpaceAddMemberShipDiscountForm',

  touchOnBlur: false,
  validate: validate };


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('SpaceAddMemberShipDiscountForm', LEGACY_FORM_FIELDS)(SpaceAddMemberShipDiscountForm)));
